// Popup Manager Utility
let popupCallback = null;

export const setPopupCallback = (callback) => {
  popupCallback = callback;
};

export const showPopup = (config) => {
  if (popupCallback) {
    popupCallback(config);
  }
};

// Convenience functions for different popup types
export const showSuccessPopup = (message, title = 'Success') => {
  showPopup({
    open: true,
    title,
    message,
    type: 'success',
    confirmText: 'OK'
  });
};

export const showErrorPopup = (message, title = 'Error') => {
  showPopup({
    open: true,
    title,
    message,
    type: 'error',
    confirmText: 'OK'
  });
};

export const showWarningPopup = (message, title = 'Warning') => {
  showPopup({
    open: true,
    title,
    message,
    type: 'warning',
    confirmText: 'OK'
  });
};

export const showInfoPopup = (message, title = 'Information') => {
  showPopup({
    open: true,
    title,
    message,
    type: 'info',
    confirmText: 'OK'
  });
};

export const showConfirmPopup = (message, title = 'Confirm', onConfirm, onCancel) => {
  showPopup({
    open: true,
    title,
    message,
    type: 'warning',
    confirmText: 'Yes',
    cancelText: 'No',
    showCancel: true,
    onConfirm,
    onCancel
  });
};
